/* Letter picker for the initial and monogram pieces (Seréa, Esme, Aveline, Haven); replaces the Zepto personalizer.
   - Each choice (a letter, or the shared birthstone) is a slim row that opens to its options and folds once one is
     chosen; the next row still to choose opens by itself. The letters and stone settings follow the finish.
   - Only the first row starts open, or every row when the snippet asks for it (openAll, Haven).
   - Order properties: each row's key (from the snippet) with its value, then _pplr_customization_id (empty).
   - Every row is required before Add to bag / Buy it now. */
(function () {
  'use strict';
  var root = document.querySelector('[data-eelt]');
  if (!root || root.__eelt) return;
  root.__eelt = true;
  var CFG = JSON.parse(root.getAttribute('data-cfg')), OPEN_ALL = !!CFG.openAll;
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- the theme's finish buttons ---------- */
  function finishValue() {
    var f = document.querySelector('fieldset[data-handle="' + CFG.finishOpt + '"]'), r = f && f.querySelector('input:checked');
    return r ? r.value : (CFG.finish || '');
  }
  function metal() { return /silver|white|platinum/i.test(finishValue()) ? 'silver' : 'gold'; }

  /* ---------- the rows ---------- */
  var picks = $$('[data-eenp-pick]', root).map(function (el) {
    var P = {
      el: el, key: el.getAttribute('data-key'), noun: el.getAttribute('data-noun') || 'option', value: '',
      letter: el.classList.contains('eenp-pick--letter'),
      head: el.querySelector('[data-eenp-pick-head]'), panel: el.querySelector('[data-eenp-pick-panel]'),
      text: el.querySelector('[data-eenp-pick-text]'), dot: el.querySelector('[data-eenp-pick-dot]'),
      dotL: el.querySelector('[data-eelt-dot]'), err: el.querySelector('[data-eenp-pick-err]'),
      opts: $$('[data-eenp-opt]', el)
    };
    P.empty = P.text ? P.text.textContent : '';
    return P;
  });
  function current(P) { return P.opts.filter(function (o) { return o.getAttribute('data-value') === P.value; })[0] || null; }
  function setOpen(P, open) {
    P.el.classList.toggle('is-open', open);
    P.head.setAttribute('aria-expanded', open ? 'true' : 'false');
    P.panel.hidden = !open;
  }
  function drawPick(P) {
    var cur = current(P);
    P.el.classList.toggle('is-empty', !cur);
    P.text.textContent = cur ? cur.getAttribute('data-name') : P.empty;
    P.opts.forEach(function (o) { o.setAttribute('aria-pressed', o === cur ? 'true' : 'false'); });
    if (P.letter && P.dotL) {                                   // the chosen letter, small, in the row's circle
      P.dotL.textContent = cur ? P.value : '';
      P.dotL.style.setProperty('--i', cur ? cur.getAttribute('data-i') : '0');
    } else {                                                    // a stone: its spot on the picture strip
      var pos = cur && cur.getAttribute('data-pos');
      P.dot.style.backgroundPosition = pos || '';
    }
  }
  function pickError(P, msg) {
    if (!P.err) return;
    P.err.textContent = msg || ''; P.err.hidden = !msg; P.el.classList.toggle('is-invalid', !!msg);
  }
  function hh() { return parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0; }
  /* bring an opened row's choices into view when they would sit below the screen */
  function reveal(el) {
    requestAnimationFrame(function () {
      var b = el.getBoundingClientRect(), vh = window.innerHeight || document.documentElement.clientHeight, top = hh() + 8;
      if (b.bottom > vh - 12) window.scrollTo({ top: Math.max(0, Math.min(b.top + window.pageYOffset - top, b.bottom + window.pageYOffset - vh + 24)), behavior: 'smooth' });
    });
  }
  function nextEmpty(after) {
    var i = picks.indexOf(after);
    for (var j = i + 1; j < picks.length; j++) if (!picks[j].value) return picks[j];
    for (j = 0; j < i; j++) if (!picks[j].value) return picks[j];
    return null;
  }
  picks.forEach(function (P) {
    P.head.addEventListener('click', function () {
      var open = !P.el.classList.contains('is-open');
      setOpen(P, open);
      if (open) reveal(P.el);
    });
    P.opts.forEach(function (o) {
      o.addEventListener('click', function () {
        P.value = o.getAttribute('data-value');
        drawPick(P); pickError(P, ''); setOpen(P, false);
        var nx = nextEmpty(P);
        if (nx && !nx.el.classList.contains('is-open')) { setOpen(nx, true); reveal(nx.el); }
        syncProps();
      });
    });
    drawPick(P);
  });
  /* start with the first row open, or every row (openAll) */
  picks.forEach(function (P, i) { setOpen(P, OPEN_ALL || i === 0); });

  /* ---------- line-item properties inside the real product form ---------- */
  function productForm() {
    var ref = document.querySelector('fieldset[data-handle="' + CFG.finishOpt + '"] input[type="radio"]');
    var id = ref && ref.getAttribute('form');
    return (id && document.getElementById(id)) || document.querySelector('form[action*="/cart/add"][id^="product-form-"]') || document.querySelector('form[action*="/cart/add"]');
  }
  function syncProps() {
    var form = productForm(); if (!form) return;
    var box = form.querySelector('[data-eelt-props]');
    if (!box) { box = document.createElement('div'); box.setAttribute('data-eelt-props', ''); box.hidden = true; form.appendChild(box); }
    var list = [];
    picks.forEach(function (P) { if (P.value) list.push([P.key, P.value]); });
    if (list.length) list.push(['_pplr_customization_id', '']);
    var sig = JSON.stringify(list);
    if (box.getAttribute('data-sig') === sig) return;
    box.setAttribute('data-sig', sig);
    box.innerHTML = '';
    list.forEach(function (r) {
      var h = document.createElement('input');
      h.type = 'hidden'; h.name = 'properties[' + r[0] + ']'; h.value = r[1];
      box.appendChild(h);
    });
  }
  /* Zepto's own box (if the app still injects one) is removed, with its inputs (names with or without a trailing colon) */
  var ZSEL = picks.map(function (P) { return P.key; }).concat(['_pplr_customization_id']).map(function (k) {
    k = String(k).replace(/:+$/, '');
    return ['input', 'textarea', 'select'].map(function (t) { return t + '[name="properties[' + k + ']"],' + t + '[name="properties[' + k + ':]"]'; }).join(',');
  }).join(',');
  function unzep() {
    $$('.product-personalizer').forEach(function (e) { e.parentNode.removeChild(e); });
    $$(ZSEL).forEach(function (i) { if (!i.closest('[data-eelt-props]')) i.parentNode.removeChild(i); });
  }

  /* ---------- the letters and stone settings follow the finish ---------- */
  function syncMetal() { if (root.getAttribute('data-metal') !== metal()) root.setAttribute('data-metal', metal()); }

  /* ---------- the theme switches the variant (finish): follow it ---------- */
  document.addEventListener('change', function (e) {
    var t = e.target; if (!t || !t.matches) return;
    if (t.matches('fieldset[data-handle="' + CFG.finishOpt + '"] input')) setTimeout(syncMetal, 30);
  });

  /* ---------- every row is required before Add to bag / Buy it now ---------- */
  function guard(e) {
    var form = productForm(); if (!form) return;
    var missing = picks.filter(function (P) { return !P.value; });
    if (!missing.length) { unzep(); syncProps(); return; }
    var t = e.target;
    if (e.type === 'submit' && t !== form) return;
    if (e.type === 'click') {
      var b = t.closest && t.closest('button[type="submit"], button[name="add"], .shopify-payment-button__button, .shopify-payment-button [role="button"], [data-add-to-cart]');
      if (!b) return;
      if (!form.contains(b) && b.getAttribute('form') !== form.getAttribute('id')) return;
    }
    e.preventDefault(); e.stopImmediatePropagation();
    missing.forEach(function (P) { pickError(P, 'Please choose ' + (P.letter ? P.noun : 'a ' + P.noun) + '.'); });
    missing.forEach(function (P, i) { setOpen(P, OPEN_ALL || i === 0); });
    var first = missing[0].el;
    window.scrollTo({ top: Math.max(0, first.getBoundingClientRect().top + window.pageYOffset - hh() - 16), behavior: 'smooth' });
  }
  document.addEventListener('submit', guard, true);
  document.addEventListener('click', guard, true);

  /* the theme refreshes parts of the product area on variant change; keep our order details in the form */
  var moT;
  new MutationObserver(function () { clearTimeout(moT); moT = setTimeout(function () { unzep(); syncProps(); }, 60); }).observe(document.body, { childList: true, subtree: true });

  unzep(); syncProps(); syncMetal();
})();
